// © 2017 NetSuite Inc.
// User may not copy, modify, distribute, or re-bundle or otherwise make available this code;
// provided, however, if you are an authorized user with a NetSuite account or log-in, you
// may use this code subject to the terms that govern your access and use.


// Categories.js
// -------------
// Utility Class to handle the Categories tree
define('Categories.Extend',	[
    'Categories',
    'Categories.Utils',
    'SC.Configuration',
    'underscore',
    'Utils'
], function CategoriesExtend(
    Categories,
    CategoriesUtils,
    Configuration,
	_,
    Utils
) {
    'use strict';

    _.extend(Categories, {
        makeNavigationTab: function makeNavigationTab(categories) {
            var result = [];
            var self = this;
            var href;
            var tab;
            _.each(categories, function eachCategory(category) {
                if (category.custrecordhide_from_store !== 'T') {
                    href = category.fullurl;
                    tab = {
                        'href': href,
                        'text': category.name,
                        'data': {
                            hashtag: '#' + href,
                            touchpoint: 'home'
                        },
                        'class': 'header-menu-level' + category.level + '-anchor',
                        'data-type': 'commercecategory'
                    };
                    tab.additionalFields = CategoriesUtils.getAdditionalFields(category, 'categories.menu.fields');
                    tab.custrecordhide_from_store = category.custrecordhide_from_store;
                    if (category.categories) {
                        tab.categories = self.makeNavigationTab(category.categories);
                    }
                    result.push(tab);
                } else {
                    if (category.custrecordhide_from_store === 'T' && !Utils.isDesktopDevice()) {
                        href = category.fullurl;
                        tab = {
                            'href': href,
                            'text': category.name,
                            'data': {
                                hashtag: '#' + href,
                                touchpoint: 'home'
                            },
                            'class': 'header-menu-level' + category.level + '-anchor',
                            'data-type': 'commercecategory'
                        };
                        tab.additionalFields = CategoriesUtils.getAdditionalFields(category, 'categories.menu.fields');
                        tab.custrecordhide_from_store = category.custrecordhide_from_store;
                        if (category.categories) {
                            tab.categories = self.makeNavigationTab(category.categories);
                        }
                        result.push(tab);
                    }
                }
            });
            return result;
        }
	});
});

